import React from 'react';
import { useTheme } from '../../ThemeContext';

interface PipelineBasicInfoProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onPaste?: () => void;
  showPaste?: boolean;
}

export const PipelineBasicInfo: React.FC<PipelineBasicInfoProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  onPaste,
  showPaste = false,
}) => {
  const { theme } = useTheme();

  return (
    <>
      {showPaste && onPaste && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <button
            type="button"
            onClick={onPaste}
            title="Paste pipeline configuration from clipboard"
            style={{
              padding: '8px 12px',
              border: `1px solid ${theme.border}`,
              background: theme.cardBackground,
              color: theme.text,
              borderRadius: 6,
              cursor: 'pointer'
            }}
          >
            Paste
          </button>
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: theme.text }}>
          Pipeline Name *
        </label>
        <input
          type="text"
          required
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          style={{
            width: '100%',
            padding: 10,
            border: `1px solid ${theme.inputBorder}`,
            borderRadius: 6,
            fontSize: 14,
            background: theme.inputBackground,
            color: theme.text
          }}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: theme.text }}>
          Description
        </label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          rows={3}
          style={{
            width: '100%',
            padding: 10,
            border: `1px solid ${theme.inputBorder}`,
            borderRadius: 6,
            fontSize: 14,
            resize: 'vertical',
            background: theme.inputBackground,
            color: theme.text
          }}
        />
      </div>
    </>
  );
};
